// Create Match → optional stage-seating step (same venue editor as external tournaments' veto
// seating step). Off = the new match copies both teams' default seating (server side). On = the
// admin sets sides + seats here and they are sent as `seating` with POST /api/matches.
//   value = null (use the defaults) | { team1_stage_side, team1: { seats: [5] }, team2: { seats: [5] } }
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import MatchSeatingEditor, { seatingComplete } from '../ext/stage/MatchSeatingEditor';

const toTeam = (d) => ({ name: d.name, players: d.players.map(p => ({ steam_id: p.steam_id, ign: p.ign })), defaults: d.seats.length === 5 ? d.seats.map(s => s.steam_id) : null });

export { seatingComplete };

export default function SeatingStep({ team1Id, team2Id, value, onChange }) {
  const { t } = useTranslation();
  const [teams, setTeams] = useState(null);
  const [err, setErr] = useState('');

  useEffect(() => {
    setTeams(null); setErr('');
    if (!team1Id || !team2Id) return undefined;
    let alive = true;
    Promise.all([axios.get(`/api/v1/teams/${team1Id}/seating`), axios.get(`/api/v1/teams/${team2Id}/seating`)])
      .then(([a, b]) => { if (alive) setTeams({ team1: toTeam(a.data), team2: toTeam(b.data) }); })
      .catch(() => { if (alive) setErr(t('seating.loadFailed', 'Could not load the teams’ seating')); });
    return () => { alive = false; };
  }, [team1Id, team2Id, t]);

  // a team change makes a custom seating stale
  useEffect(() => { onChange(null); }, [team1Id, team2Id]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!team1Id || !team2Id) return null;
  if (err) return <div className="cmp-sec-hint gap">{err}</div>;
  if (!teams) return null;
  const short = ['team1', 'team2'].filter(k => teams[k].players.length < 5);
  if (short.length) {
    return <div className="cmp-sec-hint gap">{t('seating.createNeedsFive', 'Stage seating: each team needs 5 players (set it later on the match page).')}</div>;
  }
  const on = value != null;
  const start = () => onChange({
    team1_stage_side: 'left',
    team1: { seats: teams.team1.defaults || teams.team1.players.slice(0, 5).map(p => p.steam_id) },
    team2: { seats: teams.team2.defaults || teams.team2.players.slice(0, 5).map(p => p.steam_id) },
  });
  return (
    <div className="cmp-seating">
      <label className="cmp-seating-toggle">
        <input type="checkbox" checked={on} onChange={e => (e.target.checked ? start() : onChange(null))} />
        <span>
          <strong>{t('seating.createToggle', 'Set the stage seating now')}</strong>
          {on
            ? t('seating.createOnHint', 'Seen from the crowd. You can still change it on the match page.')
            : t('seating.createOffHint', 'Off: the match uses both teams’ default seating.')}
        </span>
      </label>
      {on && (
        <div className="cmp-seating-editor">
          <MatchSeatingEditor teams={teams} value={value} onChange={onChange} />
          {!seatingComplete(value) && <div className="cmp-error top">{t('seating.createIncomplete', 'Pick 5 different players for each team.')}</div>}
        </div>
      )}
    </div>
  );
}
